import * as types from "../actions/types";



const initialState = {
  list: null,
  loading: false
};


export default function tv_program_schedule(state = initialState, action) {
  switch (action.type) {
    case types.SET_TV_PROGRAM_SCHEDULE_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_TV_PROGRAM_SCHEDULE_WEEKS_LIST:
      return {
        ...state,
        list: action.payload
      };
    case types.SET_TV_PROGRAM_SCHEDULE_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}